import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=4af7038d&scoped=true"
var script = {}
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=4af7038d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af7038d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonComponent: require('/home/node/app/components/ui/ButtonComponent.vue').default,ControllerError: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerError.js').default})
